export default {"src":"/_next/static/media/logo.b3ed690d.svg","height":27,"width":81,"blurWidth":0,"blurHeight":0};